import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import type { RootState } from 'src/app/store/types';
import { toggleDispatchSidebar } from 'src/features/dispatch/dispatcher.slice';

export default function ToggleDispatchToolbarButton() {
  const dispatch = useAppDispatch();
  const isDispatchSidebarOpen = useAppSelector(
    (state: RootState) => state.dispatcher.isDispatchSidebarOpen
  );

  return (
    <SimpleTooltip
      trigger={
        <div className="flex">
          <Button
            className="!p-0 py-2"
            variant="ghost"
            onClick={() => {
              dispatch(toggleDispatchSidebar());
            }}
            ariaLabel={
              isDispatchSidebarOpen
                ? 'Hide Unassigned Trips'
                : 'View Unassigned Trips'
            }
          >
            {isDispatchSidebarOpen ? (
              <ChevronDoubleLeftIcon
                className="h-5 w-5"
                data-testid="chevron-double-left-icon"
              />
            ) : (
              <ChevronDoubleRightIcon
                className="h-5 w-5"
                data-testid="chevron-right-left-icon"
              />
            )}
          </Button>
        </div>
      }
      content={
        isDispatchSidebarOpen
          ? 'Hide Unassigned Trips'
          : 'View Unassigned Trips'
      }
    />
  );
}
